import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IAmplitudeFavouritesEventParams} from "./get_amplitude_favourites_event_properties";

export const trackAmplitudeAddToComparison = (params: IAmplitudeFavouritesEventParams): void => {
    trackAmplitudeEvent("add_to_comparison", {
        location: params.location,
        offer_source: "rp",
        item_id: params.offer.id,
        property_id: params.property?.id ?? null,
        item_category: params.property ? "property" : "investment"
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IAmplitudeFavouritesEventParams} from "./get_amplitude_favourites_event_properties";

export const trackAmplitudeAddToComparison = (params: IAmplitudeFavouritesEventParams): void => {
    trackAmplitudeEvent("add_to_comparison", {
        location: params.location,
        offer_source: "rp",
        item_id: params.offer.id,
        property_id: params.property?.id ?? null,
        item_category: params.property ? "property" : "investment"
    });
};
